/* eslint-disable class-methods-use-this */
import CollectionApi from 'client/api/v2/CollectionApi';

class PasswordManagerAppVersionApi extends CollectionApi {
  constructor() {
    super('/api/v2/passwordmanager/appversions', {
      skip: 0,
      limit: 10,
      sort: '', // Prepend with a '-' to reverse default sort direction
      search: '',
    });
  }

  create() {
    throw new Error('method not implemented');
  }

  delete() {
    throw new Error('method not implemented');
  }

  update() {
    throw new Error('method not implemented');
  }

  patch() {
    throw new Error('method not implemented');
  }
}

export default new PasswordManagerAppVersionApi();
